import moment from "moment/moment";
import React, { useState } from "react";
import { Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import ReactPaginate from "react-paginate";
import { useNavigate } from "react-router-dom";
import { editIcon } from "../../assets/img";
const UserWalletTransaction = ({
  wallets,
  setWalletPage,
  paginationWallet,
  walletCount,
  getWalletTransaction,
  fromDateWallet,
  toDateWallet,
  searchWallet,
}) => {
  const navigate = useNavigate();

  const handlePageChange = (selectedObject) => {
    setWalletPage(selectedObject.selected + 1);
  };

  return (
    <div>
      {" "}
      <Row md={12} sm={12} lg={12}>
        <div className="col-md-6 mt-5">
          <label className="table-labels f1">
            Total Count : {paginationWallet?.total}
          </label>
        </div>
      </Row>
      <div className="d-flex ac-jb ">
        <div className="col-md-2 mb-2 p-0">
          <DatePicker
            selected={fromDateWallet}
            onChange={(date) => {
              getWalletTransaction(date, toDateWallet, searchWallet);
            }}
            peekNextMonth
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            dateFormat="yyyy-MM-dd"
            todayButton="Today"
            className="form-control custom-select"
            placeholderText="YYYY-MM-DD"
          />
        </div>
        <div className="col-md-2 mb-2 p-0">
          <DatePicker
            selected={toDateWallet}
            onChange={(date) => {
              getWalletTransaction(fromDateWallet, date, searchWallet);
            }}
            peekNextMonth
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            dateFormat="yyyy-MM-dd"
            todayButton="Today"
            className="form-control custom-select"
            placeholderText="YYYY-MM-DD"
          />
        </div>
        <div className="col-md-4 mb-2 p-0">
          <input
            className="form-control bg-white"
            placeholder="Eg: coupon code"
            onChange={(e) =>
              getWalletTransaction(fromDateWallet, toDateWallet, e.target.value)
            }
            value={searchWallet}
          />
        </div>
      </div>
      <div className="table-custom-design overflow-scroll">
        <table>
          <thead className="single-book-table">
            <tr className="text-capitalize">
              <th>S.NO</th>
              <th>Date</th>
              <th>Amount</th>
              <th>Expiry_at</th>
              <th>Coupon code</th>
              <th>Type</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {wallets?.map((item, ind) => {
              return (
                <tr key={ind}>
                  <td>{(paginationWallet?.current_page - 1) * 10 + ind + 1}</td>
                  <td>
                    {item?.created_at
                      ? moment(item?.created_at).format("DD-MM-YYYY hh:mm a")
                      : ""}
                  </td>
                  <td>{item?.amount}</td>
                  <td>
                    {" "}
                    {item?.expiry_at
                      ? moment(item?.expiry_at).format("DD-MM-YYYY hh:mm a")
                      : ""}
                  </td>
                  <td>{item?.coupon_code}</td>
                  <td>
                    {item?.type == 1
                      ? "Transaction"
                      : item?.type == 2
                      ? "Admin Refund"
                      : item?.type == 3
                      ? "Referral Credit"
                      : item?.type == 4
                      ? "Coupon"
                      : "Booking"}
                  </td>
                  <td>
                    {item?.status == 1
                      ? "Not Used"
                      : item?.status == 2
                      ? "Used"
                      : item?.status == 3
                      ? "Expired"
                      : "Pending"}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="page-inner-cont py-2 d-flex justify-content-end">
        <ReactPaginate
          nextLabel="››"
          onPageChange={handlePageChange}
          pageRangeDisplayed={2}
          marginPagesDisplayed={2}
          pageCount={walletCount}
          previousLabel="‹‹"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          breakLabel="..."
          breakClassName="page-item"
          breakLinkClassName="page-link"
          containerClassName="pagination"
          activeClassName="active"
          renderOnZeroPageCount={null}
        />
      </div>
    </div>
  );
};

export default UserWalletTransaction;
